<app-digital-product-template-list></app-digital-product-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreateDisplayTemplateModal()">
    Create Product Template
  </lib-button-primary>
</lib-button-input-portal>
